/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {AnalysisErrorVO} from '@/valueObjects/AnalysisErrorVO'
import {NOT_AVAILABLE} from '@/utils/constants'
import {YaraSignatureVO} from '@/valueObjects/YaraSignatureVO'

export enum StatusValues {
    inProgress = 'in_progress',
    notStarted = 'not_started',
    done = 'done',
    notRequested = 'not_requested',
    error = 'error',
}

export class AnalysisVO {
    // Signature added to avoid implicit any (TS7017)
    [key: string]: any;

    public static StatusFieldList = ['mobsfStatus', 'yaraAndroguardStatus',
        'virustotalStatus', 'pfavStatus', 'dynamicAnalysisStatus', 'yaraSourceCodeStatus',
        'yaraMemoryDumpStatus', 'yaraNetworkStatus',
    ]

    public static fromServiceFormat(snakeCasedAnalysisInfo: any): AnalysisVO {
        const signatures: YaraSignatureVO[] = []
        if (snakeCasedAnalysisInfo.static_report) {
            signatures.push(...AnalysisVO.getSignaturesFromReport(snakeCasedAnalysisInfo.static_report))
        }
        if (snakeCasedAnalysisInfo.dynamic_report) {
            signatures.push(...AnalysisVO.getSignaturesFromReport(snakeCasedAnalysisInfo.dynamic_report))
        }
        return new AnalysisVO(snakeCasedAnalysisInfo.id,
            snakeCasedAnalysisInfo.user_id,
            snakeCasedAnalysisInfo.visibility,
            snakeCasedAnalysisInfo.mobsf_status,
            snakeCasedAnalysisInfo.yara_androguard_status,
            snakeCasedAnalysisInfo.yara_sourcecode_status,
            snakeCasedAnalysisInfo.yara_memorydump_status,
            snakeCasedAnalysisInfo.yara_network_status,
            snakeCasedAnalysisInfo.virustotal_status,
            snakeCasedAnalysisInfo.pfav_status,
            snakeCasedAnalysisInfo.dynamic_analysis_status,
            snakeCasedAnalysisInfo.static_analysis_is_finished,
            snakeCasedAnalysisInfo.dynamic_analysis_is_finished,
            snakeCasedAnalysisInfo.analyzer_version,
            snakeCasedAnalysisInfo.error_report,
            snakeCasedAnalysisInfo.filename,
            snakeCasedAnalysisInfo.family,
            snakeCasedAnalysisInfo.hash,
            snakeCasedAnalysisInfo.trash,
            snakeCasedAnalysisInfo.creation_date,
            snakeCasedAnalysisInfo.first_name,
            snakeCasedAnalysisInfo.last_name,
            snakeCasedAnalysisInfo.static_report,
            snakeCasedAnalysisInfo.dynamic_report,
            signatures,
            snakeCasedAnalysisInfo.ruleset_subset,
            snakeCasedAnalysisInfo.is_interactive,
            snakeCasedAnalysisInfo.interactive_connection,
            snakeCasedAnalysisInfo.app_type,
        )
    }

    public static getStatus(currentAnalysis: AnalysisVO): string {
        const isFinished = currentAnalysis.staticAnalysisIsFinished && currentAnalysis.dynamicAnalysisIsFinished
        let status = isFinished ? 'Analysis finished' : 'Analysis in progress'

        const currentStatuses = AnalysisVO.StatusFieldList.map((val) => currentAnalysis[val])
        const isInError = currentStatuses.some((val) => (val === StatusValues.error))
        if (isInError) {
            status += ' - error'
        } else if (isFinished) {
            status += ' - ok'
        }
        return status
    }

    private static getSignaturesFromReport(report: any): YaraSignatureVO[] {
        const yaraSignatures: YaraSignatureVO[] = []
        if (report.yara_matches && report.yara_matches.length > 0) {
            return report.yara_matches.map(YaraSignatureVO.fromServiceFormat)
        }
        return yaraSignatures
    }

    constructor(public id: number = 0,
                public userId: number = 0,
                public visibility: string = NOT_AVAILABLE,
                public mobsfStatus: string = NOT_AVAILABLE,
                public yaraAndroguardStatus: string = NOT_AVAILABLE,
                public yaraSourceCodeStatus: string = NOT_AVAILABLE,
                public yaraMemoryDumpStatus: string = NOT_AVAILABLE,
                public yaraNetworkStatus: string = NOT_AVAILABLE,
                public virustotalStatus: string = NOT_AVAILABLE,
                public pfavStatus: string = NOT_AVAILABLE,
                public dynamicAnalysisStatus: string = NOT_AVAILABLE,
                public staticAnalysisIsFinished: boolean = false,
                public dynamicAnalysisIsFinished: boolean = false,
                public analyzerVersion: string = NOT_AVAILABLE,
                public errorReport: AnalysisErrorVO[] = [],
                public fileName: string = NOT_AVAILABLE,
                public family: string = NOT_AVAILABLE,
                public hash: string = NOT_AVAILABLE,
                public trash: boolean = false,
                public creationDate: string = NOT_AVAILABLE,
                public firstName: string = NOT_AVAILABLE,
                public lastName: string = NOT_AVAILABLE,
                public staticReport: any = null,
                public dynamicReport: any = null,
                public signatures: YaraSignatureVO[] = [],
                public rulesetSubset: string = NOT_AVAILABLE,
                public isInteractive: boolean = false,
                public interactiveConnection: string = '',
                public app_type: string='',
    ) {

    }
}
